import { Model } from 'infra/model'
import { MessageBankReplyDTO } from 'messaging/dtos/message-bank'
import { observable, makeObservable } from 'mobx'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { MessageBank } from './MessageBank'

export class MessageBankReply extends Model<
  MessageBankReplyDTO,
  MessageBankReply
> {
  messageBank: MessageBank
  @observable id = Id.none
  @observable title = ''
  @observable content = ''
  @observable authorId = Id.none
  @observable authorPublicId = Id.none
  @observable dateCreated = DateZero()
  @observable dateModified = DateZero()

  constructor(messageBank: MessageBank) {
    super()
    makeObservable(this)
    this.messageBank = messageBank
  }

  parse(json: Partial<MessageBankReplyDTO>): Partial<MessageBankReply> {
    return {
      id: json.id,
      title: json.title,
      content: json.content,
      authorId: json.author_id,
      authorPublicId: json.author_public_id,
      dateCreated: maybeParseDate(json.date_created),
      dateModified: maybeParseDate(json.date_modified),
    }
  }
}
